import React from 'react';
import { StatusBadge, StatusTone } from './StatusBadge';

/**
 * Buyurtma holati yorliqlari — buyurtmalar ro'yxati ham, mijoz kartochkasi ham
 * bir xil rang va matnni ko'rsatishi uchun bitta joyda turadi.
 */
export const STATUS_TONE: Record<string, StatusTone> = {
  draft: 'neutral',
  confirmed: 'info',
  paid: 'success',
  partial: 'warning',
  debt: 'danger',
  cancelled: 'neutral',
};

export const STATUS_LABEL: Record<string, string> = {
  draft: 'Qoralama',
  confirmed: 'Tasdiqlangan',
  paid: "To'langan",
  partial: "Qisman to'langan",
  debt: 'Qarz',
  cancelled: 'Bekor qilingan',
};

export const renderOrderStatus = (status: string, display?: string) => (
  <StatusBadge tone={STATUS_TONE[status] || 'neutral'}>
    {STATUS_LABEL[status] || display || status}
  </StatusBadge>
);

/** Muddati o'tgan va hali to'lanmagan buyurtma. */
export const isOverdue = (dueDate: string, paid: number, total: number) =>
  new Date(dueDate) < new Date() && paid < total;
